<template>
  <div>

      <!-- Content -->
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-12">

            <h1 class="text-center">Our Blogs</h1>

            <div class="blog-wrapper">
  <article class="blog-card"   v-for="(data, index) in blogs.filter(blog => blog.status)" :key="data.id">
    <!-- <img src="https://via.placeholder.com/600x350" alt="Blog cover" class="blog-image"> -->

    <div class="blog-content">
      <h2 class="blog-title">{{ data.title }}</h2>

      <div class="blog-meta">
        <span>🗓 {{filterDate(data.created_at)}}</span>
        <span>•</span>
        <span>✍ Admin</span>
      </div>

      <p class="blog-excerpt">
        {{ excerpt(data.content, 30) }}
      </p>
      <div class="d-flex">
         <router-link  :to="{ name: 'blog', params: { id: data.id } }"    class="read-more mr-5">Read More →</router-link>
       <!-- <a  v-on:click="shareApp(data,title)"  class="read-more">Share  <i class="fa fa-share"></i></a> -->
      </div>

    </div>
  </article>

  <!-- Duplicate card for more blogs -->
</div>




          </div>
        </div>
      </div>
  </div>
</template>
<script>
 import moment from 'moment'
 export default {
     name: 'App',
      components: { },
     data(){
         return {
          proxyUrl: process.env.VUE_APP_API_URL,
             message:{discount:'0',credit:'0',amount:'0',type:'bonga',receiving_no:'',source:'app'},
                role:'false',
                phone:'',
                blogs:[],
                 settings:{bingwa:{}},
         }
     },
     created(){
        this.getBlogs();
        this.getDiscount();
     },
     methods: {
      routerPage(val,id){
         localStorage.setItem('prevRoute', this.$route.fullPath);
              this.$router.push({ name: val, params: { id } });
            },
            async shareApp(title) {
  await Share.share({
    title: title,
    text: title,
    url: this.settings.playstore.rate,
    dialogTitle: 'Share App'
  })
},
     getDiscount(){
            this.message={mpesa:'0',airtel:'0',bonga:'0',airtime:'0',airtime2:'0',send_money:'0'};
                const uri =`/api/auth/discount`;
                this.$axios.get(uri).then((response) => {
                    this.settings=response.data;
                }).catch(error => {

                });
            },
         getBlogs(){
                let uri =`/api/auth/getBlogs`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.blogs=response.data;
                }).catch(warning => {

                });
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filterDate(date){
                return moment(String(date)).format('DD/MM/YYYY HH:mm')
            },
            excerpt(html, words = 25) {
    if (!html) return ''

    // Remove HTML tags
    const text = html.replace(/<[^>]*>/g, '')

    // Limit words
    return text.split(' ').slice(0, words).join(' ') + '...'
  }
     },

 }

</script>



// WEBPACK FOOTER //
// src/components/blogs.vue